package com.example.mystybag.login.views.views

import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.example.mystybag.common.ui.views.UIView
import com.example.mystybag.login.logic.MerchantRegistrationPaymentDataViewModel
import com.example.mystybag.login.views.MerchantRegistrationPaymentDataForm
import com.example.mystybag.login.views.components.MerchantRegistrationWebBoundedColumn

@Composable
fun MerchantRegistrationPaymentDataWebView(
    viewModel: MerchantRegistrationPaymentDataViewModel
) {
    UIView(
        modifier = Modifier.fillMaxSize(),
        viewModel = viewModel,
        horizontalAlignment = Alignment.Start
    ) { _ ->
        MerchantRegistrationWebBoundedColumn(Modifier.fillMaxSize()) {
            MerchantRegistrationPaymentDataForm(viewModel)
        }
    }
}
